<!--【首页头部区域】：包含登录|注册-->
<template>
  <div class="front-page">
    <index-header></index-header>
    <router-view :key="rootKey"></router-view>
    <index-footer></index-footer>
  </div>
</template>
<script>
  import {mapActions} from "vuex";

  export default {
    name: "frontIndex",
    data() {
      return {
        //路由的key
        rootKey: new Date().getTime(),
      }
    },
    mounted() {
      if (this.$route.path == '/front/learn') {//进入首页
        //加载配置数据
        this.commitConfig();
        //加载数据字典
        this.commitDictList();
        this.$router.push("/front/home")
      }
    },
    methods:{
      ...mapActions(['commitConfig','commitDictList']),
    }
  }
</script>




// WEBPACK FOOTER //
// src/pages/front/index/index.vue